import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Footer, Sidebar, Topbar} from './components';
import {connect} from 'react-redux';
import {cartActions, userActions} from '../../_actions';
import TopSlider from '../../HomePage/components/TopSlider';
import {Container} from '@material-ui/core';
import Message2 from '../../_components/Message2';
import Favicon from 'react-favicon';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';
import ScrollTop from '../../_components/ScrollTop';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import {About} from './components/About/About';
import {GoogeMap} from './components/GoogleMap';
import {Link, useLocation} from 'react-router-dom';
import {Contacts} from './components/About/Contacts';
import {Helmet} from 'react-helmet';
import ClipBoard from '../../images/clipboard-list.svg';
import Wallet from '../../images/wallet.svg';
import List from '../../images/list.svg';
import Return from '../../images/Frame.svg';
import avatar from '../../images/Avatar.svg';
import quit from '../../images/Quit.svg';
import profile from '../../images/ico-man.svg';
import {Category} from './components/Topbar/components/MenuSideBar/components/Category';
import axInst from '../../_helpers/axios-instance';

const useStyles = makeStyles(theme => ({
  root: {
    // paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      // paddingTop: 110,
    },
    // [theme.breakpoints.up(1280)]: {
    //   paddingTop: 110,
    //   maxWidth: 1280,
    //   marginLeft: 'calc((100% - 1280px)/2)',
    // },
  },
  fullWidthRoot: {
    // paddingTop: 49,
    height: '100%',
    [theme.breakpoints.up(600)]: {
      // paddingTop: 64,
    },
  },
  content: {
    height: '100%',
  },
  slider: {
    // backgroundColor: '#757575',
  },
  mobileMenuBlock: {
    height: '138.061px',
    flexShrink: 0,
    borderRadius: '4px',
    background: '#EBF0F8',
    boxShadow: '0px 5px 6px 0px rgba(0, 0, 0, 0.02)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '20px',
  },
  mobileMenuBg: {
    width: '80px',
    height: '80px',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFBE00',
    borderRadius: '50%',
  },
  mobileMenuText: {
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '100%',
    padding: '10px 15px',
    textAlign: 'center',
  },
  MobileMenuMoneyAmount: {
    background: '#FFF2F1',
    padding: '12px 20px',
    marginTop: '20px',
  },
  MobileMenuMoneyAmountTextBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '15px',
  },
}));

const Main = props => {
  const {
    userSelectedData,
    children,
    frontendData,
    authentication,
    catalogTree,
    financeCalendarByOrganization,
  } = props;
  const theme = useTheme();
  const [options, setOptions] = useState([]);
  useEffect(
    () => {
      let active = true;
      (async () => {
        const contr = await axInst.post(
          '/api/user-select2/',
          JSON.stringify({
            _type: 'query',
            term: '',
          }),
        );
        //await sleep(1e3); // For demo purposes.
        if (active) {
          setOptions(contr.data.results);
        }
      })();
    },
    // This is the useEffect input array
    // Our useEffect function will only execute if this value changes ...
    // ... and thanks to our hook it will only change if the original ...
    // value (searchTerm) hasn't changed for more than 500ms.
    [],
  );

  const smDown = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });

  const tab = useMediaQuery(theme.breakpoints.down(780));
  const classes = useStyles();
  const icon = (
    <svg
      width="27"
      height="18"
      viewBox="0 0 27 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.29992 1.56305C1.57708 1.20919 2.02933 1.01771 2.47522 1.032C6.76014 1.032 11.0451 1.03305 15.33 1.032C15.6146 1.03094 15.9108 1.03781 16.1726 1.16264C16.6529 1.38374 16.9628 1.90157 16.9723 2.42522C16.9872 3.1012 16.9708 3.77718 16.9745 4.45316C18.3328 4.44787 19.6916 4.45475 21.0499 4.45369C21.5672 4.44787 22.0872 4.66738 22.4178 5.0699C23.4883 6.34623 24.5562 7.62414 25.6258 8.90153C25.7998 9.11152 25.9394 9.3543 26.0077 9.62035C26.0791 9.87795 26.0732 10.1477 26.0727 10.4127C26.0743 11.3637 26.0664 12.3153 26.0796 13.2663C26.0838 13.5937 26.0404 13.9338 25.8654 14.2174C25.6348 14.6066 25.2042 14.8812 24.7477 14.8928C24.3775 14.9044 24.0072 14.8933 23.637 14.8986C23.4756 15.637 23.0065 16.3098 22.349 16.6885C21.618 17.118 20.6807 17.135 19.9143 16.789C19.1447 16.4484 18.5634 15.7243 18.3999 14.8981C15.2723 14.8896 12.1453 14.8907 9.01765 14.8891C8.84892 15.6338 8.38134 16.3156 7.71329 16.6954C6.91777 17.1545 5.88581 17.1339 5.08923 16.688C4.4106 16.3204 3.9261 15.6413 3.76847 14.8886C3.35537 14.8912 2.94227 14.8917 2.52917 14.8896C2.20123 14.8865 1.85531 14.8352 1.58502 14.6352C1.19837 14.3665 0.987848 13.8905 1.00054 13.4255C1.0016 9.77586 0.998956 6.12619 1.0016 2.47652C0.995253 2.14964 1.0894 1.81694 1.29992 1.56305ZM2.07058 2.33318C2.04572 2.48552 2.06106 2.64102 2.05895 2.79441C2.05789 6.30233 2.06 9.81024 2.05683 13.3182C2.05895 13.416 2.05313 13.5155 2.07323 13.6117C2.11977 13.7582 2.27634 13.8487 2.42656 13.8365C2.87668 13.8339 3.32681 13.8402 3.77694 13.8333C3.94778 12.9728 4.56188 12.2069 5.38332 11.8874C6.0117 11.6308 6.74057 11.6081 7.37054 11.872C8.19462 12.2005 8.84098 12.9542 9.01395 13.8275C11.3095 13.8476 13.6057 13.8296 15.9018 13.8365C15.9229 12.5877 15.9102 11.3394 15.9134 10.0906C15.9145 7.55221 15.9124 5.01437 15.9145 2.47599C15.933 2.31044 15.8214 2.12637 15.6495 2.10256C15.4395 2.08088 15.2279 2.09939 15.0174 2.09304C10.8208 2.09463 6.62421 2.09304 2.42762 2.09357C2.27422 2.08247 2.10338 2.17344 2.07058 2.33318ZM16.9829 5.51051C16.9692 8.2869 16.9808 11.0633 16.9771 13.8397C17.4484 13.8397 17.9202 13.8381 18.3915 13.8407C18.5729 13.0283 19.1119 12.2862 19.8815 11.9434C20.5554 11.6277 21.3641 11.5906 22.0486 11.8958C22.8562 12.2354 23.4693 12.9849 23.6481 13.8418C23.9987 13.8328 24.35 13.8476 24.7001 13.8365C24.8842 13.8381 25.0291 13.6583 25.009 13.4795C25.009 12.3333 25.0085 11.1871 25.009 10.0409C25.018 9.88482 24.9498 9.73884 24.8546 9.6193C23.7851 8.34191 22.715 7.06506 21.6444 5.78873C21.5149 5.62264 21.3186 5.50046 21.1023 5.51104C19.7292 5.50998 18.356 5.51157 16.9829 5.51051ZM6.15768 12.7734C5.42405 12.8712 4.81154 13.5308 4.79144 14.2745C4.69729 15.0584 5.32355 15.8158 6.08839 15.947C6.72735 16.0766 7.42608 15.7767 7.76354 15.2176C8.18087 14.5908 8.03118 13.6805 7.48267 13.1801C7.13357 12.8506 6.63003 12.7046 6.15768 12.7734ZM20.6326 12.8072C19.9825 12.9574 19.4726 13.5509 19.4139 14.2142C19.3002 15.0245 19.936 15.829 20.7363 15.9512C21.3879 16.0745 22.094 15.7513 22.4178 15.171C22.8071 14.5421 22.6388 13.6604 22.0956 13.1743C21.7116 12.8146 21.1398 12.6813 20.6326 12.8072Z"
        fill="#1F1F1F"
        stroke="#1F1F1F"
        strokeWidth="0.6"
      />
    </svg>
  );
  const icon2 = (
    <svg
      width="25"
      height="15"
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.41735 1.6797C5.16104 1.25034 6.00731 0.990669 6.86402 1.00143C8.90609 0.99996 10.9482 1.00094 12.9902 1.00045C13.2937 1.00192 13.6 0.988712 13.9006 1.04202C14.4714 1.14373 15.0114 1.42492 15.4279 1.83961C16.2119 2.64503 16.9946 3.45192 17.7777 4.25832C17.9952 4.47887 18.1999 4.72876 18.4862 4.85835C18.7256 4.98159 18.9967 5.00653 19.2603 5.00653C19.8145 5.00555 20.3687 5.00653 20.9229 5.00555C21.2421 5.00457 21.565 5.0256 21.8718 5.1234C22.8999 5.41975 23.7225 6.34645 23.9148 7.42866C24.0687 8.4248 24.1883 9.42681 24.3408 10.4229V10.4904C24.3218 10.7594 24.2686 11.0313 24.129 11.2631C23.8834 11.6998 23.4066 11.9922 22.9151 11.9922C22.4003 11.9991 21.8855 11.9898 21.3708 11.9966C21.2083 12.8152 20.6318 13.5341 19.8705 13.8305C19.2271 14.0887 18.4748 14.0486 17.8651 13.7131C17.2287 13.3732 16.7543 12.7272 16.6199 12.001C13.9904 11.9849 11.3608 11.9996 8.73133 11.9937C8.57128 12.7585 8.06694 13.4422 7.37217 13.7688C6.62515 14.1322 5.69815 14.0637 5.01239 13.5879C4.47148 13.2295 4.10249 12.6358 3.96429 11.9932C2.9765 11.9952 1.98871 11.9947 1.00045 11.9937C1.0071 11.6299 0.988103 11.265 1.0147 10.9017C1.02847 9.77695 0.996651 8.65219 1.01992 7.52744C1.07976 6.52201 1.32813 5.52636 1.76266 4.62264C2.34584 3.40644 3.26382 2.34575 4.41735 1.6797ZM2.64882 5.0031C4.0455 5.00995 5.44218 5.00359 6.83933 5.00653C6.85263 4.00158 6.8417 2.99566 6.84455 1.99072C5.04801 2.09195 3.37209 3.31108 2.64882 5.0031ZM7.80147 1.98436C7.80005 2.99126 7.79862 3.99816 7.80195 5.00506C10.9144 5.00506 14.0269 5.00946 17.1389 5.0031C16.3862 4.20111 15.6083 3.42405 14.8466 2.63085C14.5455 2.30516 14.1442 2.07337 13.7102 2.00784C13.4081 1.97067 13.1032 1.98632 12.7998 1.9829C11.1334 1.98387 9.46742 1.98094 7.80147 1.98436ZM2.26748 5.98702C2.10222 6.4824 2.02053 7.00419 1.97779 7.52451C1.96022 8.68643 1.97304 9.84834 1.96972 11.0103C2.636 11.0117 3.30181 11.0098 3.96762 11.0108C4.13193 10.2044 4.69184 9.49576 5.43885 9.19208C6.13268 8.9016 6.95663 8.9637 7.59679 9.36666C8.17617 9.72022 8.58648 10.3335 8.72753 11.0093C11.3566 11.0127 13.9861 11.0093 16.6156 11.0108C16.7771 10.1662 17.3906 9.43463 18.1813 9.15393C18.7845 8.93436 19.4731 8.96908 20.0486 9.25956C20.7206 9.58867 21.2212 10.2562 21.3651 11.0073C21.8651 11.0132 22.3647 11.0117 22.8648 11.0083C23.1502 11.0313 23.4062 10.7491 23.3739 10.4591C23.2694 9.69332 23.1616 8.92751 23.0557 8.16121C23.0101 7.8502 22.9868 7.52989 22.8648 7.23745C22.6468 6.68534 22.1786 6.24767 21.6239 6.077C21.3347 5.98164 21.0269 5.98555 20.7268 5.988C14.574 5.98702 8.42074 5.98897 2.26748 5.98702ZM5.98309 10.042C5.48444 10.1711 5.06891 10.5868 4.93546 11.0988C4.77115 11.6631 4.97773 12.3101 5.42318 12.6754C5.88288 13.0749 6.59001 13.1214 7.101 12.7996C7.6894 12.449 7.97196 11.6504 7.72786 10.9941C7.49374 10.2777 6.69116 9.83905 5.98309 10.042ZM18.6178 10.0449C17.9486 10.2136 17.4609 10.9178 17.5307 11.625C17.5663 12.1878 17.9415 12.7057 18.4516 12.9082C19.0015 13.136 19.6792 12.981 20.0743 12.5223C20.4138 12.1472 20.5335 11.5912 20.4034 11.0998C20.2999 10.7071 20.032 10.3662 19.6844 10.1745C19.3615 9.99407 18.9725 9.94908 18.6178 10.0449Z"
        fill="#1F1F1F"
        stroke="#1F1F1F"
        strokeWidth="0.6"
      />
    </svg>
  );
  const icon3 = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.83534 0.801117C9.75233 0.840179 9.64002 0.92807 9.58143 1.00131C9.47401 1.13315 9.47401 1.16244 9.47401 2.93491V4.73667H8.81483H8.15565V3.9017V3.06674L7.98963 2.90073C7.8578 2.76889 7.78455 2.73471 7.62342 2.73471C7.3744 2.73471 7.2035 2.81284 7.09608 2.97397C7.02284 3.08139 7.0033 3.23764 6.99354 3.94077L6.97401 4.78549L6.77381 4.83432C5.74842 5.09799 4.88905 5.93784 4.63514 6.92905L4.57166 7.17807H3.83924C3.43397 7.17807 3.01893 7.20249 2.92127 7.2269C2.58436 7.31967 2.41346 7.70053 2.55995 8.01792C2.70155 8.31577 2.81873 8.34995 3.73182 8.34995H4.54237V9.00913V9.66831H2.9994C1.28553 9.66831 1.25135 9.67319 1.09998 9.99057C1.00233 10.2005 1.00721 10.347 1.1244 10.5374C1.30018 10.8255 1.39784 10.8402 3.05311 10.8402H4.54237V11.4701V12.1048L3.71717 12.1195C2.78455 12.1341 2.67713 12.1732 2.5453 12.515C2.46229 12.7445 2.50623 12.9154 2.71131 13.1205L2.87245 13.2816H3.70741H4.54725L4.5326 13.9261L4.51795 14.5755L2.95545 14.5999C1.18787 14.6292 1.17811 14.6292 1.07069 14.9906C0.997445 15.2298 1.08534 15.4935 1.28553 15.6449C1.41737 15.7425 1.48573 15.7474 2.98475 15.7621L4.54237 15.7767V16.4115V17.0414H3.74159C2.99452 17.0414 2.93592 17.0462 2.77967 17.1537C2.5453 17.3099 2.45252 17.5882 2.55506 17.8324C2.69666 18.1693 2.83827 18.2132 3.77088 18.2132H4.58143L4.61561 18.4134C4.67909 18.7845 5.05018 19.4437 5.39198 19.7806C5.83631 20.2249 6.19764 20.4251 6.92518 20.6351C6.96912 20.6449 6.98377 20.8451 6.98377 21.4115C6.98377 22.2464 7.02284 22.4173 7.25233 22.598C7.4867 22.7835 7.92127 22.7054 8.06776 22.4466C8.1117 22.3783 8.141 22.0511 8.15565 21.5091L8.18006 20.679H8.81483H9.44959L9.47401 22.2806L9.49842 23.8871L9.65955 24.0287C9.96229 24.2972 10.4164 24.1849 10.5775 23.7992C10.6312 23.6722 10.6459 23.3011 10.6459 22.1439V20.6546H11.2806H11.9154V21.4408C11.9154 22.0414 11.9349 22.2611 11.9887 22.3832C12.1303 22.6761 12.4916 22.7884 12.7943 22.6322C13.0531 22.5003 13.0873 22.3587 13.0873 21.4603V20.6546H13.7221H14.3568V22.0804C14.3568 22.8665 14.3812 23.599 14.4056 23.7064C14.5473 24.3265 15.3871 24.3265 15.5287 23.7064C15.5531 23.599 15.5775 22.8665 15.5775 22.0804V20.6546H16.2123H16.8471V21.4603C16.8471 22.0902 16.8617 22.305 16.9203 22.4124C17.0619 22.681 17.4525 22.7884 17.7211 22.6273C17.9701 22.4808 17.9945 22.4027 18.0189 21.4896L18.0433 20.64L18.2973 20.5765C18.932 20.4154 19.5717 19.9515 19.9623 19.3705C20.1869 19.0287 20.4115 18.5013 20.4115 18.306C20.4115 18.2279 20.4945 18.2181 21.2904 18.2035L22.1693 18.1888L22.3256 18.0277C22.4623 17.891 22.4867 17.8373 22.4867 17.6273C22.4867 17.4173 22.4623 17.3636 22.3256 17.2269L22.1693 17.0658L21.3148 17.0511L20.4603 17.0365V16.4017V15.7718L21.9398 15.7669C22.9457 15.7669 23.4681 15.7474 23.5853 15.7083C23.9027 15.596 24.0639 15.2005 23.9076 14.8978C23.7611 14.6195 23.7953 14.6244 22.0765 14.5999L20.4848 14.5755L20.4701 13.9261L20.4555 13.2816H21.2709C22.1742 13.2816 22.3012 13.2474 22.4379 12.9593C22.5355 12.7494 22.5306 12.6078 22.4135 12.4173C22.2474 12.1439 22.1205 12.1097 21.2416 12.1097H20.4603V11.4749V10.8402H21.9496C23.5267 10.8402 23.6537 10.8255 23.8441 10.6058C23.976 10.4642 24.0053 10.1566 23.9076 9.97104C23.7562 9.67807 23.7025 9.66831 21.9984 9.66831H20.4555L20.4701 9.01889L20.4848 8.37436L21.3148 8.34995C22.267 8.32065 22.3695 8.28647 22.4672 7.9642C22.5355 7.7396 22.5062 7.58823 22.3646 7.40756C22.2181 7.22202 21.9935 7.17807 21.1586 7.17807H20.4213L20.3871 6.97788C20.3676 6.87045 20.265 6.59702 20.1527 6.38217C19.7865 5.63999 19.0346 5.02475 18.2533 4.82944L18.0189 4.77573V3.99448C18.0189 3.14487 17.9799 2.95932 17.7601 2.81772C17.599 2.71518 17.2474 2.7103 17.101 2.81284C16.8812 2.9642 16.8471 3.11557 16.8471 3.95541V4.73667H16.2172H15.5824L15.5678 2.9642C15.5531 1.42612 15.5433 1.17709 15.4701 1.05014C15.2601 0.664398 14.6742 0.664398 14.4642 1.05014C14.391 1.17709 14.3812 1.42612 14.3666 2.9642L14.3519 4.73667H13.7172H13.0873V3.95541C13.0873 3.11557 13.0531 2.9642 12.8334 2.81284C12.6869 2.7103 12.3353 2.71518 12.1742 2.81772C11.9594 2.95932 11.9154 3.14975 11.9154 3.97983V4.73667H11.2806H10.6459V3.00327C10.6459 1.13803 10.6312 1.02573 10.3969 0.869476C10.2162 0.752288 10.0062 0.727874 9.83534 0.801117ZM18.2728 6.06967C18.6342 6.24545 18.976 6.59213 19.1371 6.93393L19.264 7.20249V12.7201V18.2376L19.1273 18.5062C18.9467 18.8578 18.6586 19.1458 18.3217 19.3167L18.0433 19.4583H12.5014H6.95936L6.65174 19.2923C6.28553 19.0921 6.04139 18.8333 5.86561 18.4623L5.73866 18.1888V12.6957V7.20249L5.87537 6.92417C6.07069 6.52866 6.49061 6.15268 6.891 6.01596L7.2035 5.91342L12.599 5.92319L17.9945 5.93295L18.2728 6.06967Z"
        fill="black"
      />
      <path
        d="M8.55078 8.41298C8.45801 8.44715 8.33594 8.53505 8.28223 8.60829C8.17969 8.74501 8.17969 8.76454 8.17969 12.7196C8.17969 16.6747 8.17969 16.6942 8.28223 16.8309C8.33594 16.9042 8.43848 16.997 8.50195 17.0263C8.58984 17.0751 9.52734 17.0897 12.54 17.0897C16.8467 17.0897 16.666 17.1044 16.8223 16.7968C16.8857 16.6698 16.8955 16.1718 16.8857 12.6757C16.8711 8.77919 16.8711 8.70106 16.7734 8.59364C16.5537 8.34462 16.6318 8.3495 12.54 8.35438C9.70801 8.35438 8.67285 8.36903 8.55078 8.41298ZM15.6748 12.7196V15.9179H12.501H9.32715V12.7538C9.32715 11.0106 9.3418 9.5702 9.36133 9.55555C9.37598 9.53602 10.8066 9.52137 12.5352 9.52137H15.6748V12.7196Z"
        fill="black"
      />
    </svg>
  );
  const icon4 = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 218 209"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M191.989 208.999C177.645 208.999 165.977 197.32 165.977 182.966C165.977 173.014 171.587 164.347 179.807 159.968L177.902 155.097C176.983 155.505 176.081 155.978 175.204 156.524C160.298 165.81 161.551 181.592 161.939 184.583C162.165 185.109 162.254 185.697 162.174 186.291C161.89 188.419 161.644 190.255 141.476 194.487C129.268 197.047 114.062 196.727 103.451 196.005C94.0031 195.362 84.6132 192.483 76.2994 187.675L58.9917 177.665C59.3567 179.402 59.5422 181.179 59.5422 182.967C59.5422 197.322 47.873 209 33.5295 209C19.1861 209 7.51804 197.322 7.51804 182.967C7.51804 171.454 15.0245 161.661 25.3977 158.236L4.21607 145.986C3.3778 145.501 2.82727 144.638 2.74285 143.672C2.65843 142.705 3.04843 141.759 3.7892 141.135C3.99729 140.954 9.216 136.347 9.216 128.037C9.216 120.948 3.22084 113.619 0.910533 111.393C0.0377755 110.55 -0.238083 109.262 0.216132 108.137C0.669157 107.011 1.7607 106.274 2.97233 106.274H73.9677C73.9891 106.274 74.0093 106.274 74.0319 106.274C74.6597 106.287 80.2589 106.497 83.2482 109.656C84.543 111.024 85.1934 112.752 85.1304 114.651C84.9247 120.807 81.9997 127.479 77.8499 131.257C77.8463 131.261 77.8428 131.265 77.8392 131.267C74.4374 134.366 72.1592 138.267 78.4599 145.764C86.5763 155.418 99.4096 156.144 99.5392 156.151C108.396 156.712 133.036 157.322 141.143 153.524C150.498 149.145 156.735 134.128 155.661 124.614C154.928 118.113 140.439 91.6216 131.784 75.7944C126.091 65.3853 123.087 59.8589 122.362 57.8038C121.576 55.5737 121.702 53.3757 122.727 51.4455C123.858 49.3154 125.862 47.9433 127.521 47.1186L123.116 27.0811C121.967 27.0169 120.818 26.6801 119.767 26.0482L118.658 25.3806C116.98 24.3726 115.795 22.7697 115.319 20.8681C114.843 18.9664 115.139 16.9934 116.148 15.3131L123.196 3.56403C124.206 1.88373 125.808 0.696096 127.708 0.22128C129.61 -0.253537 131.58 0.0415872 133.258 1.05072L134.366 1.71594C137.834 3.80085 138.958 8.31815 136.876 11.7859L129.828 23.5349C129.513 24.0573 129.144 24.5273 128.731 24.9415L133.444 46.376C136.048 46.8604 140.718 47.8088 144.597 49.0226C150.554 50.885 158.172 55.801 161.688 64.0133C162.754 66.498 162.752 69.0042 161.687 71.2593C160.896 72.9324 159.614 74.2629 158.245 75.2982C164.856 78.8658 176.652 86.6783 191.835 102.769C215.747 128.108 212.564 153.67 212.416 154.747C212.289 155.684 211.723 156.504 210.895 156.955C210.064 157.407 209.07 157.438 208.215 157.039C208.063 156.969 195.525 151.259 183.614 153.382L185.341 157.797C187.463 157.234 189.691 156.936 191.989 156.936C206.332 156.936 218 168.614 218 182.968C218 197.322 206.331 208.999 191.989 208.999ZM181.991 165.557C175.978 169.03 171.922 175.532 171.922 182.966C171.922 194.04 180.923 203.049 191.989 203.049C203.054 203.049 212.055 194.039 212.055 182.966C212.055 171.893 203.054 162.883 191.989 162.883C190.455 162.883 188.961 163.057 187.525 163.384L190.319 170.532C190.866 170.458 191.424 170.421 191.989 170.421C198.9 170.421 204.525 176.048 204.525 182.967C204.525 189.886 198.902 195.514 191.989 195.514C185.075 195.514 179.452 189.886 179.452 182.967C179.452 178.731 181.562 174.977 184.784 172.705L181.991 165.557ZM33.4035 162.883C22.3965 162.952 13.4633 171.935 13.4633 182.966C13.4633 194.04 22.4643 203.049 33.5295 203.049C44.5948 203.049 53.597 194.04 53.597 182.966C53.597 179.489 52.6803 176.068 50.9419 173.026L44.4628 169.278L42.0098 173.733C44.5032 176.027 46.0668 179.317 46.0668 182.966C46.0668 189.884 40.4438 195.512 33.5307 195.512C26.6176 195.512 20.9947 189.885 20.9947 182.966C20.9947 176.047 26.6176 170.42 33.5307 170.42C34.6639 170.42 35.7626 170.571 36.8065 170.854L39.3142 166.301L33.4035 162.883ZM10.3456 142.658L79.2744 182.522C86.807 186.878 95.3062 189.487 103.854 190.068C114.087 190.762 128.711 191.084 140.257 188.663C150.158 186.585 154.296 185.235 155.969 184.552C155.485 179.191 155.36 161.879 172.063 151.472C184.263 143.872 199.476 147.564 206.651 150.041C206.486 142.353 204.124 124.452 187.514 106.85C165.273 83.282 150.679 78.3089 150.533 78.2613C149.294 77.8555 148.458 76.6869 148.48 75.3815C148.503 74.0772 149.365 72.9372 150.617 72.573C151.781 72.2267 155.348 70.7678 156.315 68.7055C156.538 68.2307 156.729 67.5345 156.223 66.354C153.503 59.9993 147.517 56.1663 142.823 54.699C138.581 53.3721 133.086 52.3475 131.175 52.0108C130.117 52.3987 128.51 53.2162 127.973 54.242C127.816 54.5407 127.673 54.9894 127.967 55.8224C128.565 57.5182 132.661 65.0069 136.998 72.936C149.967 96.6506 160.768 116.858 161.568 123.945C162.913 135.865 155.541 153.351 143.661 158.912C132.52 164.127 100.561 162.175 99.2075 162.09C98.6201 162.062 83.6774 161.214 73.9094 149.592C68.617 143.296 67.2556 137.325 69.8263 132.035H42.9361C33.0622 132.035 25.0303 123.996 25.0303 114.114V112.221H9.33014C12.0911 116.107 15.1612 121.824 15.1612 128.034C15.1612 134.798 12.5061 139.747 10.3456 142.658ZM187.078 178.57C186.034 179.738 185.398 181.279 185.398 182.966C185.398 186.604 188.354 189.562 191.989 189.562C195.623 189.562 198.579 186.604 198.579 182.966C198.579 179.54 195.956 176.716 192.613 176.4L194.757 181.882C195.355 183.412 194.6 185.138 193.072 185.736C191.538 186.335 189.818 185.58 189.22 184.05L187.078 178.57ZM33.5295 176.37C29.8946 176.37 26.9387 179.328 26.9387 182.966C26.9387 186.604 29.8946 189.562 33.5295 189.562C37.1644 189.562 40.1204 186.604 40.1204 182.966C40.1204 181.588 39.6971 180.308 38.9706 179.248L36.1324 184.402C35.3405 185.842 33.5307 186.366 32.0944 185.572C30.6568 184.778 30.1348 182.97 30.9267 181.531L33.7662 176.375C33.6877 176.371 33.6092 176.37 33.5295 176.37ZM30.9767 112.223V114.116C30.9767 120.716 36.3428 126.087 42.9372 126.087H74.6181C77.2114 123.242 79.0508 118.631 79.1888 114.452C79.1995 114.144 79.1329 113.961 78.9355 113.75C78.0259 112.784 75.4219 112.27 73.9261 112.223H30.9767ZM129.486 5.95121C129.349 5.95121 129.231 5.97144 129.148 5.99286C128.94 6.04522 128.551 6.19635 128.294 6.62594L121.244 18.375C120.986 18.8034 121.035 19.2175 121.087 19.4258C121.138 19.634 121.289 20.0219 121.718 20.279L122.828 20.9466C123.029 21.068 123.249 21.131 123.47 21.1418C123.812 20.8597 124.223 20.6503 124.684 20.5432C124.701 20.5194 124.715 20.4944 124.73 20.4694L131.78 8.72037C132.175 8.06348 131.961 7.20905 131.306 6.81397L130.199 6.14875C129.942 5.99524 129.692 5.95121 129.486 5.95121Z"
        fill="black"
      />
    </svg>
  );
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openListOfUsers, setOpenListOfUsers] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };
  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const [showCategoryList, setShowCategoryList] = useState(false);
  const [catalogs, setCatalogs] = useState([]);
  const handleCloseCategoryList = () => setShowCategoryList(!showCategoryList);

  const shouldOpenSidebar = openSidebar;

  const footer = document.getElementById('footer');
  const header = document.getElementById('header');

  const [footerHeight] = useState(
    footer !== null && window.onload ? footer.offsetHeight : 0,
  );

  const [headerHeight, setHeaderHeight] = useState(
    header !== null ? (smDown ? 66 : header.offsetHeight) : 0,
  );

  const [showSearch, setShowSearch] = useState(false);

  const [contentHeight, setContentHeight] = useState(
    footer !== null && header != null
      ? window.innerHeight - (footerHeight + headerHeight)
      : 0,
  );

  // const [state, _dispatch] = useReducer(setHeaderHeight, setContentHeight);
  let location = useLocation();

  useEffect(() => {
    axInst
      .post('/api/get-main-product-groups/')
      .then(res => setCatalogs(res.data.result));
  }, []);
  useEffect(() => {
    if (footer != null && header != null) {
      if (smDown) {
        if (showSearch) {
          setHeaderHeight(108);
          setContentHeight(window.innerHeight - (footer.offsetHeight + 108));
        } else {
          setHeaderHeight(56);
          setContentHeight(window.innerHeight - (footer.offsetHeight + 56));
        }
      } else {
        setHeaderHeight(header.offsetHeight);
        setContentHeight(
          window.innerHeight - (footer.offsetHeight + header.offsetHeight),
        );
      }
    }
  }, [footer, header, headerHeight, smDown, showSearch]);

  // const updateProgress = () => {
  //   const scroll = document.documentElement.scrollTop;
  //   const height = document.body.scrollHeight - window.innerHeight;
  //   const progress = 307 - (scroll * 307) / height;
  //   document.getElementById(
  //     'progress-wrap-path',
  //   ).style.strokeDashoffset = progress;
  // };
  // useEffect(() => {
  //   window.addEventListener('scroll', updateProgress);
  // }, []);

  const MobileMain = () => {
    const mobileMenuItems = [
      {icon: ClipBoard, text: 'Замовлення', link: '/profile/orders'},
      {
        icon: Wallet,
        text: 'Видатковi накладнi та ТТН',
        link: '/profile/invoice/',
      },
      {icon: List, text: 'Фінанси', link: '/profile/finance/'},
      {icon: Return, text: 'Повернення', link: '/profile/reconciliation'},
    ];
    const MobileMenuItem = ({icon, text, link}) => {
      return (
        <Link to={link}>
          <div className={classes.mobileMenuBlock}>
            <div className={classes.mobileMenuBg}>
              <img src={icon} />
            </div>
            <p className={classes.mobileMenuText}>{text}</p>
          </div>
        </Link>
      );
    };
    const MobileMenuMoneyAmount = ({amount, balance}) => {
      return (
        <>
          <div className={classes.MobileMenuMoneyAmount}>
            <div className={classes.MobileMenuMoneyAmountTextBlock}>
              <p>ДАНI-ПАРТС (готiвка) </p>
              <p>{amount}</p>
            </div>
            <div className={classes.MobileMenuMoneyAmountTextBlock}>
              <p style={{color: '#FF5252'}}>ДАНI-ПАРТС (готiвка) </p>
              <p style={{color: '#FF5252'}}>{balance}</p>
            </div>
            <div style={{display: 'flex', gap: '20px'}}>
              <p style={{color: '#FFBE00', textDecoration: 'underline'}}>
                Оплатити
              </p>
              <p style={{textDecoration: 'underline'}}>
                Зателефонувати менеджеру
              </p>
            </div>
          </div>
        </>
      );
    };
    const CategoryItem = ({icon, text, url, id}) => {
      return (
        <Link to={`/categories/${url}/${id}`}>
          <div
            style={{
              height: '56px',
              flexShrink: 0,
              borderRadius: '90px',
              border: '2px solid #FFBE00',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom:'20px'
            }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '15px',
              }}>
              {icon}
              <p
                style={{
                  color: '#1F1F1F',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  lineHeight: '120%',
                }}>
                {text}
              </p>
            </div>
          </div>
        </Link>
      );
    };

    const MobileFooter = ({}) => {
      return (
        <>
          <div
            style={{
              position: 'fixed',
              bottom: '0',
              width: '100%',
              display: 'flex',
              padding: '16px 20px',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#1F1F1F',
            }}>
            <div
              onClick={() => setOpenListOfUsers(!openListOfUsers)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <img src={avatar} />
                <div>
                  <p
                    style={{
                      color: '#fff',
                      fontFamily: 'Rubik',
                      fontSize: '12px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '16px',
                    }}>
                    {userSelectedData.customer_name}
                  </p>
                  <p
                    style={{
                      color: '#fff',
                      fontFamily: 'Rubik',
                      fontSize: '12px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '16px',
                    }}>
                    {userSelectedData?.customer_discount_group}
                  </p>
                </div>
              </div>
            </div>
            <Link to="/sign-out" className="logout">
              <img src={quit} />
            </Link>
          </div>
        </>
      );
    };

    const MobileUserInfoModal = ({amount, balance, users}) => {
      const MobileUserBio = ({name, discount, currency}) => {
        {
          return (
            <div style={{display: 'flex', gap: '10px', marginTop: '25px'}}>
              <img src={profile} />
              <div>
                <p
                  style={{
                    color: '#fff',
                    fontFamily: 'Rubik',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '16px',
                  }}>
                  {name}
                </p>
                <p
                  style={{
                    color: '#777',
                    fontFamily: 'Rubik',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                  }}>
                  {discount} {currency}
                </p>
              </div>
            </div>
          );
        }
      };

      return (
        <div style={{marginBottom: '-8px'}}>
          <div
            style={{
              // position: 'fixed',
              // bottom: '304px',
              // width: '100%',

              background: '#202020',
              borderRadius: '10px 10px 0px 0px',
              boxShadow: '0px 18px 40px 0px rgba(0, 0, 0, 0.05)',
              padding: '25px 15px',
            }}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#FFF',
                  fontFamily: 'Montserrat',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '140%',
                }}>
                ДАНI-ПАРТС (готiвка)
              </p>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#FFF',
                  fontFamily: 'Montserrat',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '140%',
                }}>
                {amount}
              </p>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#FF5252',
                  fontFamily: 'Montserrat',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '140%',
                }}>
                ДАНI-ПАРТС (готiвка)
              </p>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: '#FF5252',
                  fontFamily: 'Montserrat',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '140%',
                }}>
                {balance}
              </p>
            </div>
            <div
              style={{
                background: 'rgba(147, 153, 162, 0.2)',
                width: '322.917px',
                height: '1px',
                margin: '10px 0',
              }}></div>
            <div
              style={{
                color: '#777',
                fontFamily: 'Montserrat',
                fontSize: '13px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: '140%',
              }}>
              {userSelectedData?.customer_discount_group}
            </div>
          </div>
          <div
            style={{
              // position: 'fixed',
              // bottom: '73px',
              // width: '100%',
              background: '#000',
              boxShadow: '0px 18px 40px 0px rgba(0, 0, 0, 0.05)',
              padding: '15px 25px',
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
            }}>
            {users.map(user => {
              return (
                <MobileUserBio
                  discount={user.discount_group}
                  name={user.text}
                  currency={user.credit_limit_currency}
                />
              );
            })}
          </div>
        </div>
      );
    };

    return (
      <>
        <div style={{marginBottom: '80px'}}>
          <div
            style={{
              marginBottom: '10px',
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gridTemplateRows: 'repeat(2, 1fr)',
              gridColumnGap: '20px',
              gridRowGap: '20px',
              padding: '0 15px',
            }}>
            <MobileMenuItem
              icon={mobileMenuItems[0].icon}
              text={mobileMenuItems[0].text}
              link={mobileMenuItems[0].link}
            />
            <MobileMenuItem
              icon={mobileMenuItems[1].icon}
              text={mobileMenuItems[1].text}
              link={mobileMenuItems[1].link}
            />
            <MobileMenuItem
              icon={mobileMenuItems[2].icon}
              text={mobileMenuItems[2].text}
              link={mobileMenuItems[2].link}
            />
            <MobileMenuItem
              icon={mobileMenuItems[3].icon}
              text={mobileMenuItems[3].text}
              link={mobileMenuItems[3].link}
            />
          </div>
          {!openListOfUsers && (
            <MobileMenuMoneyAmount
              amount={
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.credit_limit -
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.full_payment
              }
              balance={
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.full_payment * -1
              }
            />
          )}

          {!openListOfUsers && (
            <div
              style={{
                padding:"20px",
                // display: 'flex',
                // flexWrap: 'wrap',
                // gap: '20px',
                // justifyContent: 'center',
                // margin: '20px 0',
                // alignItems: 'center',
              }}>
              <div
                style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   gap: '20px',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                }}>
                <CategoryItem
                  icon={icon}
                  text="Вантажна група"
                  url={catalogs[0]?.url_repr}
                  id={catalogs[0]?.id}
                />
                <CategoryItem
                  icon={icon2}
                  text="Легкова група"
                  url={catalogs[1]?.url_repr}
                  id={catalogs[1]?.id}
                />
              </div>
              <div
                style={{
                //   display: 'flex',
                //   flexDirection: 'column',
                //   gap: '20px',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                }}>
                <CategoryItem
                  icon={icon3}
                  text={
                    <>
                      Радіоелектроніка <br />
                      та мікросхеми
                    </>
                  }
                  url={catalogs[2]?.url_repr}
                  id={catalogs[2]?.id}
                />
                <CategoryItem
                  icon={icon4}
                  text={<>Електротранспорт</>}
                  url={catalogs[3]?.url_repr}
                  id={catalogs[3]?.id}
                />
              </div>
            </div>
          )}
          {openListOfUsers && (
            <MobileUserInfoModal
              users={options}
              amount={
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.credit_limit -
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.full_payment
              }
              balance={
                financeCalendarByOrganization?.result?.organization_data[0]
                  ?.full_payment * -1
              }
            />
          )}

          <MobileFooter />
        </div>
      </>
    );
  };

  return (
    <div
      className={
        props.fullWidthLayout
          ? classes.fullWidthRoot
          : clsx({[classes.root]: true})
      }
      id="inner_root">
      <Favicon url={frontendData.logo && frontendData.logo.favicon} />
      <Message2 />
      <Topbar
        setShowSearch={setShowSearch}
        setHeaderHeight={setHeaderHeight}
        onSidebarOpen={handleSidebarOpen}
        //onSidebarOpenRight={handleSidebarOpenRight}
        frontendData={frontendData}
        authentication={authentication}
        location={props?.children?.props?.location}
        className="header"
      />
      {/* <Sidebar
        onSidebarClose={handleSidebarClose}
        frontendData={frontendData}
        authentication={authentication}
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={'temporary'}
        className={'sidebar_left_content'}
      /> */}
      {/*<SidebarRight
        onSidebarClose={handleSidebarCloseRight}
        frontendData={frontendData}
        authentication={authentication}
        onClose={handleSidebarCloseRight}
        open={shouldOpenSidebarRight}
        variant={'temporary'}
      />*/}
      {location.pathname !== '/' && (
        <main
          className={classes.content}
          style={{
            minHeight: contentHeight + headerHeight,
            paddingTop: headerHeight,
          }}>
          {props.HomePage && (
            <div className={classes.slider}>
              <TopSlider />
            </div>
          )}
          {props.CategoriesPage && (
            <div className={classes.slider}>
              <TopSlider />
            </div>
          )}

          {props.fullWidthLayout ? (
            children
          ) : (
            <div className="main_container">{children}</div>
          )}
        </main>
      )}
      {tab && location.pathname == '/profile' ? (
        <MobileMain />
      ) : (
        <main
          className={classes.content}
          style={{
            minHeight: contentHeight + headerHeight,
            paddingTop: headerHeight,
          }}>
          {props.HomePage && (
            <div className={classes.slider}>
              <TopSlider />
            </div>
          )}
          {props.CategoriesPage && (
            <div className={classes.slider}>
              <TopSlider />
            </div>
          )}

          {props.fullWidthLayout ? (
            children
          ) : (
            <div className="main_container">{children}</div>
          )}
        </main>
      )}
      {/* {props.withOutAboutSection ? <></> : <About />} */}
      {props.withMap && !tab ? <Contacts /> : <></>}
      {/* <GoogeMap /> */}
      {/* <Footer frontendData={frontendData} /> */}
      {!tab && (
        <ScrollTop {...props}>
          <Fab size="small" aria-label="scroll back to top">
            <ArrowUpwardIcon />
          </Fab>
        </ScrollTop>
      )}
      {/* <Hidden mdUp>
            </Hidden> */}
    </div>
  );
};

const getWindowHeith = () => {
  return window.innerHeight;
};

Main.propTypes = {
  children: PropTypes.node,
};

class MainWrapper extends React.Component {
  componentDidMount() {
    this.props.getFrontendData();
    // this.props.getContragentData(this.props.customer_id);
    // if (!this.props.cart || !this.props.cart.list)
    // this.props.getCart();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>
            Запчастини для вантажних/легкових автомобілів в інтернет-магазині
            DaniParts
          </title>
          <meta
            name="description"
            content="Продаж запчастин і комплектуючих для вантажних автомобілів з доставкою по Україні. Інтернет-магазин запчастин для вантажних/легкових автомобілів, електроніки, від відомих виробників за доступними цінами - DaniParts"
          />
          <link rel="canonical" href={`http://mysite.com/example`} />
        </Helmet>
        <Main {...this.props} />
      </>
    );
  }
}

function mapState(state) {
  const {frontendData, userSelectedData, financeCalendarByOrganization} = state;
  const {authentication} = state;
  const {customer_id} = userSelectedData;
  const catalogTree = state.catalogTree && state.catalogTree.data;
  return {
    userSelectedData,
    frontendData,
    authentication,
    customer_id,
    catalogTree,
    financeCalendarByOrganization,
  };
}

const actionCreators = {
  getFrontendData: userActions.getFrontendData,
  getPaymentCalendarByOrganization:
    userActions.getPaymentCalendarByOrganization,
  getCart: cartActions.getCart,
  getContragentData: userActions.getContragentData,
};

const MobileMainComponent = connect(mapState, actionCreators)(MainWrapper);

export default MobileMainComponent;
